import { Root } from '@insurgrid/common';

function getRootRegex() {
  return Object.values(Root).reduce(
    (acc, cur) => (acc.length ? `${acc}|${cur}` : cur),
    '',
  );
}

export const BASE_PATH = '/[agentSlug]';
const RESOURCE_ROOT = `${BASE_PATH}/[root]`;

export const PATH = {
  BASE_PATH,
  LANDING: `${BASE_PATH}/landing`,
  PERSONAL: `${BASE_PATH}/personal`,
  AU_ROOT: RESOURCE_ROOT,
  AU_CREATE: `${RESOURCE_ROOT}/create`,
  AU_UPDATE: `${RESOURCE_ROOT}/[rootId]/update`,
  AU_QUESTION: `${RESOURCE_ROOT}/[rootId]/[questionName]`,
  AU_FETCHING: `${RESOURCE_ROOT}/fetching`,
  SUCCESS: `${BASE_PATH}/success`,
  SUMMARY: `${BASE_PATH}/summary`,
};

const CANCELLATION_ROOT = '/[agentSlug]/request/[cancellationId]';
export const CANCELLATION_PATH = {
  BASE_PATH: CANCELLATION_ROOT,
  LANDING: `${CANCELLATION_ROOT}/landing`,
  SIGNATURE: `${CANCELLATION_ROOT}/signature`,
  HAS_PRIOR_AGENT: `${CANCELLATION_ROOT}/has-prior-agent`,
  PRIOR_AGENT_INFO: `${CANCELLATION_ROOT}/prior-agent-info`,
  CONFIRM_POLICY: `${CANCELLATION_ROOT}/confirm-policy`,
  CLIENT_ADDRESS: `${CANCELLATION_ROOT}/client-address`,
  CONFIRM_CLIENT_INFO: `${CANCELLATION_ROOT}/confirm-client-info`,
  PREVIEW: `${CANCELLATION_ROOT}/preview`,
  SUCCESS: `${CANCELLATION_ROOT}/success`,
};

export const SENTRY_MONITORING_TUNNEL_ROUTE = 'monitoring-tunnel';
